/**
 * As cores de significado do §1 do design system, como classes. Fora de `base.tsx` para que
 * uma tela possa pintar um bloco com a mesma tinta do badge sem inventar cor.
 */
export type Significado = "verde" | "amarelo" | "vermelho" | "azul" | "cinza";

/** §3: fundo tingido a 14%, borda a 40%, texto na cor cheia. */
export const TINTA: Record<Significado, string> = {
  verde: "text-verde bg-verde-fundo border-verde-borda",
  amarelo: "text-amarelo bg-amarelo-fundo border-amarelo-borda",
  vermelho: "text-vermelho bg-vermelho-fundo border-vermelho-borda",
  azul: "text-azul bg-azul-fundo border-azul-borda",
  cinza: "text-cinza bg-cinza-fundo border-cinza-borda",
};
